import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default Line.extend({
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, {
      ...this.options,
      animation: {
        duration: 0,
        onComplete: () => {
          this.$emit('onAnimationComplete');
        }
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/components/Charts/LineChartImp.js